var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronUp = function SvgChevronUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.512 8.43C11.6479 8.31353 11.821 8.24952 12 8.24952C12.179 8.24952 12.3521 8.31353 12.488 8.43L19.488 14.43C19.5629 14.4941 19.6244 14.5723 19.669 14.6601C19.7136 14.748 19.7405 14.8438 19.7481 14.942C19.7557 15.0403 19.7439 15.139 19.7134 15.2327C19.6828 15.3264 19.6341 15.4131 19.57 15.488C19.5059 15.5629 19.4277 15.6243 19.3399 15.669C19.252 15.7136 19.1562 15.7405 19.058 15.7481C18.9597 15.7557 18.861 15.7439 18.7673 15.7134C18.6736 15.6828 18.5869 15.6341 18.512 15.57L12 9.987L5.488 15.568C5.41385 15.6359 5.3268 15.6882 5.23203 15.7218C5.13727 15.7554 5.03671 15.7696 4.93635 15.7635C4.83599 15.7575 4.73786 15.7313 4.64782 15.6866C4.55777 15.6418 4.47764 15.5795 4.41218 15.5031C4.34673 15.4268 4.29729 15.3381 4.2668 15.2423C4.23631 15.1465 4.2254 15.0455 4.23471 14.9454C4.24402 14.8453 4.27337 14.7481 4.321 14.6595C4.36864 14.571 4.43359 14.4929 4.512 14.43L11.512 8.43Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronUp);
export default ForwardRef;